import {useIntl} from 'react-intl'
import {CrudProvider} from '../../../../../services/loggedin/CrudContext'
import {ListComponent} from '../../../../parts/crud/List'
import {ActionType, ColumnType} from '../../../../parts/crud/Types'
import {useEffect, useRef, useState} from 'react'
import {processGet, processPost} from '../../../../../services/api'
import Map from 'ol/Map'
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'

import Feature from 'ol/Feature'
import {Point} from 'ol/geom'
import {fromLonLat} from 'ol/proj'

import OSM from 'ol/source/OSM'
import Style from 'ol/style/Style'
import Icon from 'ol/style/Icon'
import Swal from 'sweetalert2'
import SweetAlertPosition from 'sweetalert2-react-content'
import withReactContent from 'sweetalert2-react-content'
import {Navigate} from 'react-router-dom'
import {useAuth} from '../../../auth'
import {Loader} from '@googlemaps/js-api-loader'
const MySwal = withReactContent(Swal)

export const ServerList = () => {
  const ROLE_MANAGER = parseInt(process.env.REACT_APP_ROLE_MANAGER + '')
  const ROLE_EMPLOYEE = parseInt(process.env.REACT_APP_ROLE_EMPLOYEE + '')
  const intl = useIntl()
  const [serverCoordinates, setServerCoordinates] = useState([])
  const [redirect, setRedirect] = useState('')
  const columns: Array<ColumnType> = [
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SERVER_DESCRIPTION'}),
      key: 'serverDescription',
      type: 'text',
      orderable: true,
    },
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SERVER_HOST'}),
      key: 'serverHost',
      type: 'text',
      orderable: true,
    },
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SERVER_CODE'}),
      key: 'serverCode',
      type: 'text',
      orderable: true,
    },
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.LICENSE'}),
      key: 'licenseToken',
      type: 'text',
      orderable: true,
    },
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SERVER_STATUS'}),
      key: 'serverStatus',
      type: 'custom',
      orderable: true,
      render_on_null: true,
      render: (row) => {
        console.log(row.serverStatus)
        switch (row.serverStatus) {
          case 0 || null || '0':
            return (
              <>
                <i className='fa-regular fa-circle-check text-danger fs-4 me-1'></i>
                {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.OFFLINE'})}
              </>
            )

          case 1:
            return (
              <>
                <i className='fa-regular fa-circle-check text-warning fs-4 me-1'></i>
                {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.NOT_LOGGED_IN'})}
              </>
            )
          case 2:
            return (
              <>
                <i className='fa-regular fa-circle-check text-success fs-4 me-1'></i>
                {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.ONLINE'})}
              </>
            )
          default:
            console.log(row.serverStatus)
            return (
              <>
                <i className='fa-regular fa-circle-check text-danger fs-4 me-1'></i>
                {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.OFFLINE'})}
              </>
            )
        }
      },
    },
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.LAST_ONLINE'}),
      key: 'lastOnlineStatus',
      type: 'datetime',
      orderable: true,
    },
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.LAST_OFFLINE'}),
      key: 'lastOfflineStatus',
      type: 'datetime',
      orderable: true,
    },
  ]
  const mapElement = useRef<any>()
  const [map, setMap] = useState<Map>()
  const [featuresLayer, setFeaturesLayer] = useState<any>()
  const featureStyle = function (feature, resolution) {
    var image: null | string = null
    if (feature.get('serverStatus') === 2) {
      image = '/media/server-online.png'
    } else {
      image = '/media/server-offline.png'
    }
    var style = new Style({
      image: new Icon({
        anchor: [0.5, 46],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: image,
      }),
    })
    return [style]
  }
  const {checkAuthorization} = useAuth()
  useEffect(() => {
  
    const fetchCoordinates = async (loader) => {
      const {Map} = await loader.importLibrary('maps')
      const {Marker} = await loader.importLibrary('marker')
      const {LatLngBounds, Size, Point, ControlPosition} = await loader.importLibrary('core')
      const response: any = await processGet('system-settings/servers/coordinates')

      const map = new Map(mapElement.current, {
        center: {lat: 0, lng: 0},
        zoom: 13,
        zoomControl: true,
        zoomControlOptions: {
          position: ControlPosition.TOP_RIGHT,
        },
      })
      const bounds = new LatLngBounds()

      response.data.forEach((server: any) => {
        if (server.lat == null || server.lng == null) return

        var image: null | string = null
        if (server.serverStatus === 2) {
          image = '/media/server-online.png'
        } else {
          image = '/media/server-offline.png'
        }
        const marker = new Marker({
          position: {lat: parseFloat(server.lat), lng: parseFloat(server.lng)},
          map: map,
          title: server.serverDescription,
          icon: {
            url: image,
            scaledSize: new Size(40, 40), // Ora funziona
            origin: new Point(0, 0), // Ora funziona
            anchor: new Point(20, 40), // Ora funziona
          },
        })

        marker.addListener('click', () => {
          handleMarkerClick(server)
        })
        bounds.extend(marker.getPosition())
      })

      map.fitBounds(bounds)
    }

    const initMap = async () => {
      const loader = new Loader({
        apiKey: window['config'].gmaps_api_key,
        version: 'weekly',
        libraries: [], // opzionale, se serve Places API
      })

      fetchCoordinates(loader)
    }

    initMap()
  }, [])

  function handleMarkerClick(data: any) {
    var content = `<h3>Server ${data.serverDescription}</h3>
                  <strong>${intl.formatMessage({
                    id: 'SYSTEM_SETTINGS.SERVERS.SERVER_STATUS',
                  })}: </strong> ${data.serverStatus === 2 ? 'online' : 'offline'}
                  <strong>${intl.formatMessage({
                    id: 'SYSTEM_SETTINGS.SERVERS.USERNAME',
                  })}: </strong> ${data.serverUsername}
                  <strong>${intl.formatMessage({
                    id: 'SYSTEM_SETTINGS.SERVERS.LAST_ONLINE',
                  })}: </strong> ${intl.formatDate(data.lastOnlineStatus)} ${intl.formatTime(
      data.lastOnlineStatus
    )}
                  <strong>${intl.formatMessage({
                    id: 'SYSTEM_SETTINGS.SERVERS.LAST_OFFLINE',
                  })}: </strong> ${intl.formatDate(data.lastOfflineStatus)} ${intl.formatTime(
      data.lastOfflineStatus
    )}`
    let position: any = [920, 283]
    MySwal.fire({
      toast: false,
      position: position,
      confirmButtonText: intl.formatMessage({id: 'GENERIC.EDIT'}),
      cancelButtonText: intl.formatMessage({id: 'GENERIC.OK'}),
      showCancelButton: true,
      showConfirmButton: checkAuthorization([ROLE_MANAGER]),
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer
        toast.onmouseleave = Swal.resumeTimer
      },

      title: content,
    }).then((result) => {
      if (result.isConfirmed) {
        setRedirect(`/system-settings/servers/edit/${data.id}`)
      }
    })
  }

  let actions: ActionType[] = [
    {
      title: 'GENERIC.EDIT',
      type: 'link',
      action: 'edit',
      icon: 'fa-solid fa-pencil',
      condition: (record) => checkAuthorization([ROLE_MANAGER]),
    },
    {
      title: 'SYSTEM_SETTINGS.SERVERS.RESET_EVENTS',
      type: 'link',
      action: 'reset_events',
      icon: 'fa-solid fa-rotate-left',
      condition: (record) => checkAuthorization([ROLE_MANAGER]),
    },

    {
      type: 'divider',
      condition: (record) => checkAuthorization([ROLE_MANAGER]),
    },
    {
      title: 'GENERIC.DELETE',
      type: 'link',
      action: 'delete',
      textColor: 'danger',
      icon: 'fa-solid fa-trash',
      condition: (record) => checkAuthorization([ROLE_MANAGER]),
    },
  ]
  if (!checkAuthorization([ROLE_MANAGER])) {
    actions = []
  }
  const resetEvents = async (id: number) => {
    MySwal.fire({
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.RESET_EVENTS'}),
      text: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SURE_RESET_EVENTS'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.YES_RESET_EVENTS'}),
      cancelButtonText: intl.formatMessage({id: 'GENERIC.NO_CANCEL'}),
    }).then(async (response: any) => {
      if (response.value) {
        await processPost('system-settings/servers/' + id + '/reset-events')
        MySwal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer
            toast.onmouseleave = Swal.resumeTimer
          },
          icon: 'success',
          title: intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.EVENTS_RESETTED'}),
        })
      }
    })
  }
  return (
    <>
      {redirect && <Navigate to={redirect} />}
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div
            ref={mapElement}
            style={{width: '100%', height: '500px'}}
            className='map-container'
          ></div>
        </div>
      </div>

      <CrudProvider api='system-settings/servers'>
        <ListComponent
          menuClicked={(action, data) => {
            if (action === 'reset_events') {
              resetEvents(data.id)
              return false
            }
            return true
          }}
          columns={columns}
          actions={actions}
          defOrder='serverDescription'
          perPage={20}
          defOrderDir='asc'
          title_delete={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.DELETE_SERVER'})}
          text_eliminare={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SURE_DELETE'})}
          text_eliminato={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SERVER_DELETED'})}
          text_nuovo={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.ADD_SERVER'})}
          newButton={checkAuthorization([ROLE_MANAGER])}
        ></ListComponent>
      </CrudProvider>
    </>
  )
}
